import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { OtherOption } from '../MiniComponents';
import { OpenLoginSignUp } from '../../../../../../Actions/ToggleSignupA';
import login from '../../../../Assets/login.png'
import "./LeftSide.css"
const SignInLeftSide = ({ TopLoginRegisterBtns, ScreenSize, setCredentials, userType }) => {
    const Dispatch = useDispatch()
    const { AuthPageName } = useSelector((Store) => Store.ToggleSignupReducer);


    let SignUpbtnColor = AuthPageName === "Sign Up" ? " bg-white text-[#A1A3EF] " : " bg-[#EAEFF4] text-black ";
    let ContinueHeading = ScreenSize > 768 ? `Client ${AuthPageName}` : `${AuthPageName} with`


    let ButtonStyle = `flex items-center gap-5 justify-center
    border-[1px] border-[#FEFEFE]
  
    cursor-pointer  lg:min-w-[400px]  max-w-[625px]
    font-normal rounded-lg
    md:py-2                 xl:py-3 
    md:px-6     lg:px-10    xl:px-16    2xl:px-20 
    DropShadow`
    // DropShadow
    let h4Style = `text-left font-normal  whitespace-nowrap 
        text-4xs md:text-[19px] lg:text-xs   xl:text-base  2xl:text-[30px]
        w-auto   md:w-[220px]   lg:w-[250px] xl:w-[290px]  2xl:w-[350px]`;
    const OnClick = () => {
        Dispatch(OpenLoginSignUp("Sign Up", true))
        setCredentials({
            Email: "",
            Password: "",
            ConfirmPassword: "",
            FirstName: "",
            LastName: ""
        })
    }

    return (
        <div className={`hidden md:block
                        w-full md:w-[56%] md:basis-[44%]
                        gap-4 md:gap-8 lg:gap-10 xl:gap-16 2xl:gap-24
                        justify-between items-start relative`}
        >
            {/* <button type='button' className={`${TopLoginRegisterBtns} ${SignUpbtnColor}  -right-[1px] `}
                onClick={OnClick}
            >
                Sign Up
            </button> */}

            <div className='hidden md:block w-full h-full back-image'>
                <img 
                className={`relative w-full ${userType === "Partner" ? "top-[0px]" : "top-[-9px]"}`} // Conditional top value
                height={userType === "Partner" ? "100%" : "106%"} // Conditionally set height 
                // src={require('../../../../Assets/login.png')} 
                src={
                    userType === "Partner"
                        ? require("../../../../Assets/partnersignin.png") // Partner image
                        : require("../../../../Assets/login.png") // Default login image
                    }
                alt="" 
                style={{position: 'relative' }} />
            </div>


            {/* <ContinuesWith ButtonStyle={ButtonStyle} h4Style={h4Style} ContinueHeading={ContinueHeading} />

            <div className='w-full flex flex-col gap-2 md:gap-3 xl:gap-6 mb-4 md:mb-20 items-center'>

                <OtherOption MobileDisplay={"inline"} DesktopDisplay={"hidden"} AuthPageName={AuthPageName} />

                {
                    AuthPageName === "Sign Up" ?
                        <>

                            <h4 className='text-3xs md:text-base xl:text-[30px] font-normal text-white md:text-black w-full text-center md:text-left'>
                                Partner Sign Up
                            </h4>

                            <button className={`w-full ${ButtonStyle} justify-start py-2 px-0 bg-white `}
                                onClick={() => {
                                    Dispatch(OpenLoginSignUp("Register", true));
                                    setCredentials({
                                        Email: "",
                                        Password: "",
                                        ConfirmPassword: "",
                                        FirstName: "",
                                        LastName: ""
                                    })
                                }}
                                type="button"
                            >
                                <img className='w-6 xl:w-10'
                                    src={require('../../../../Assets/Institute Icon.png')} alt=""
                                />
                                <h5 className={` ${h4Style} inline-block`}>
                                    Register as a Partner
                                </h5>
                            </button>

                        </>
                        : null
                }
            </div> */}

        </div>)
}
export default SignInLeftSide